import axiosInstance from "../../utils/axios/axiosInstance";
import { handleApiError } from "../../utils/errorHandler/apiError";

const adminApi = {
  // Admin Registration
  registerAdmin: async (adminData) => {
    try {
      const response = await axiosInstance.post("/admin/register", adminData);
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to register admin");
    }
  },

  // Admin Login
  login: async (credentials) => {
    try {
      const response = await axiosInstance.post("/admin/login", credentials);
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to login");
    }
  },

  // Get Admin Profile
  getProfile: async () => {
    try {
      const response = await axiosInstance.get("/admin/profile");
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to fetch admin profile");
    }
  },

  // Dashboard Stats
  getDashboardStats: async () => {
    try {
      const response = await axiosInstance.get("/admin/dashboard-stats");
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to fetch dashboard stats");
    }
  },

  // Update Admin Profile
  updateProfile: async (profileData) => {
    try {
      const response = await axiosInstance.put("/admin/profile", profileData);
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to update profile");
    }
  },

  // Change Password
  changePassword: async (passwordData) => {
    try {
      const response = await axiosInstance.put(
        "/admin/change-password",
        passwordData
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to change password");
    }
  },

  // Admin Logout
  logout: async () => {
    try {
      const response = await axiosInstance.post("/admin/logout");
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to logout");
    }
  },

  // Forgot Password - Request OTP
  requestPasswordResetOTP: async (email) => {
    try {
      const response = await axiosInstance.post(
        "/admin/forgot-password/request-otp",
        {
          email,
        }
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to send OTP");
    }
  },

  // Verify OTP and Reset Password
  verifyOTPAndResetPassword: async (resetData) => {
    try {
      const response = await axiosInstance.post(
        "/admin/forgot-password/verify-otp",
        resetData
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to reset password");
    }
  },

  // Resend OTP
  resendPasswordResetOTP: async (email) => {
    try {
      const response = await axiosInstance.post(
        "/admin/forgot-password/resend-otp",
        {
          email,
        }
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to resend OTP");
    }
  },

  // Validate OTP (optional)
  validatePasswordResetOTP: async ({ email, otp }) => {
    try {
      const response = await axiosInstance.post(
        "/admin/forgot-password/validate-otp",
        {
          email,
          otp,
        }
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to validate OTP");
    }
  },

  // Keep old method for backward compatibility (optional)
  forgotPassword: async ({ email, newPassword }) => {
    try {
      const response = await axiosInstance.post("/admin/forgot-password", {
        email,
        newPassword,
      });
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to reset password");
    }
  },

  // Reset Password with OTP
  resetPassword: async (resetData) => {
    try {
      const response = await axiosInstance.post(
        "/admin/reset-password",
        resetData
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, "Failed to reset password");
    }
  },
};

export default adminApi;
